/** @format */
import axios from 'axios';

import { ContentfulQueryId } from '@toucan/common/contentful';
import { normalizeIsoCode } from '@toucan/common/helpers/language';

import { ContentfulQueryVariables } from '../config/types';

/**
 * Generic Contentful data fetcher
 */
export const getContentfulData = async <R = unknown>(
    queryId: ContentfulQueryId,
    locale: string,
    variables?: ContentfulQueryVariables
): Promise<R> => {
    const normalizedLocale = normalizeIsoCode(locale);

    const { data } = await axios.post('/cms/contentful', {
        locale: normalizedLocale,
        queryId,
        variables,
    });

    return data?.data ?? null;
};
